import { _, ref, watch, storage, App } from '@zto/zpage'

// 10秒钟内只能请求一次
const AreaRequestDuration = 20000

let __lastRequestTime: number | null = null

let __areas = ref<any[]>([])
let __areasLevel1 = ref<any[]>([])
let __areasLevel2 = ref<any[]>([])

let __flatten_areas_map: Record<string, string> = {}

export const areaSeparator = '---'

export function getAreasRef(level = -1) {
  switch (level) {
    case 1:
      return __areasLevel1
    case 2:
      return __areasLevel2
    default:
      return __areas
  }
}

watch(
  () => __areas.value,
  () => {
    const a1: any[] = []
    const a2: any[] = []

    ;(__areas.value || []).forEach(p => {
      const _p1 = _.omit(p, 'children')
      a1.push({ ..._p1 })

      const _p2 = { ..._p1, children: [] }
      ;(p.children || []).forEach((c: any) => {
        const _c1 = _.omit(c, 'children')
        _p2.children.push(_c1)
      })

      a2.push(_p2)
    })

    __areasLevel1.value = a1 || []
    __areasLevel2.value = a2 || []
  }
)

/** 获取区域列表 */
let __loading = false
export async function loadAreas(app: App) {
  const appApi = app.api

  if (__areas.value?.length || !appApi?.getAreaListByQcp) return __areas

  if (__loading) return __areas

  try {
    __loading = true

    // 防止报错
    let data = storage.page.get('areasQcp') || []

    if (!data?.length) {
      // 防止过去频繁请求接口，导致应用卡死卡死
      if (!__lastRequestTime || new Date().getTime() - __lastRequestTime > AreaRequestDuration) {
        __lastRequestTime = new Date().getTime()

        data = await appApi!.getAreaListByQcp()
        storage.page.set('areasQcp', data)
      }
    }

    __areas.value = normalizeAreas(data)
    __loading = false
  } catch (ex) {
    __loading = false
    console.error(ex)
  }

  return __areas
}

// 解析区域值
export function getAreaData(val: string) {
  if (!val) return []
  return __flatten_areas_map[val]
}

// 格式化区域
function normalizeAreas(data: any, level = 0): any[] {
  if (!data || !Array.isArray(data)) return []

  data.forEach(it => {
    if (!it) return
    it.label = it.name
    it.value = String(it.code)
    it.level = level
    __flatten_areas_map[it.value] = _.omit(it, ['children'])

    normalizeAreas(it.children, level + 1)
  })

  return data
}
